import React, {Component} from 'react';
import {Checkbox} from '@homeaway/react-form-components';

class CheckboxWithValidation extends Component {
    state = {
        error: this.props.error,
    };

    validate = () => {
        const valid = !!this.props.checked;
        this.setState({error: !valid});
        return valid;
    };

    render() {
        /* eslint-disable-next-line no-unused-vars */
        return (
            <Checkbox
                {...this.props}
                error={this.props.checked ? false : this.state.error}
            />
        );
    }
}

export default CheckboxWithValidation;
